import React, {useEffect, useState} from "react";
import {Form, FormikProps} from "formik";
import Input from "../../Elements/Form/Input";
import Button from "../../Elements/Button";
import useQuery from "../../../hook/useQuery";
import httpClient from "../../../services/httpClient";
import {blogsApi} from "../../../constans/apiUrls";
import Loading from "../../Elements/Loading/Loading";
import useToastNotify from "../../../hook/useToastNotify";
import {useHistory} from "react-router-dom";
import {ISelectOptionsItem} from "../../../contracts/select_options";
import {BlogFileType} from "../../../constans/enumTypes";
import {generateBlogFileTypeTitle} from "../../../helpers/functions";
import InputSelect from "../../Elements/Form/InputSelect";
import InputFile from "../../Elements/Form/InputFile";
import {IBlogCategoryListData, IBlogData} from "../../../contracts/data/blog";
import MyCKEditor from "../../Elements/MyCKEditor";


const InnerBlogForm = (props: FormikProps<IBlogData>) => {
    const queryParams = useQuery()
    const history = useHistory()
    const {toastNotify} = useToastNotify()
    const [loading, setLoading] = useState<boolean>(true)
    const [loadingCategory, setLoadingCategory] = useState<boolean>(true)
    const options:Array<ISelectOptionsItem> = [
        {value: BlogFileType.NONE, label:generateBlogFileTypeTitle(BlogFileType.NONE)},
        {value: BlogFileType.AUDIO, label:generateBlogFileTypeTitle(BlogFileType.AUDIO)},
        {value: BlogFileType.VIDEO, label:generateBlogFileTypeTitle(BlogFileType.VIDEO)},
    ]
    const [optionsCategories, setOptionsCategories] = React.useState<Array<ISelectOptionsItem>>([])

    const handleFetchPrevData = async () => {
        await httpClient().get(`${blogsApi.update}/${queryParams.get('id')}`)
            .then(response => {
                if (response.status === 200){
                    props.setValues(response?.data?.data)
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    const handleFetchCategories = async () => {
        await httpClient().get(blogsApi.categories_list)
            .then(response => {
                if (response.status === 200) {
                    const array_option: Array<ISelectOptionsItem> = []
                    response?.data?.map((item: IBlogCategoryListData, _: number) => {
                        array_option.unshift({value: item.id, label: item?.title})
                    })
                    setOptionsCategories(array_option)
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoadingCategory(false))
    }

    useEffect(() => {
        handleFetchCategories()
        if(props?.status?.formType === 'edit' && queryParams.get('id')){
            handleFetchPrevData()
        }else {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        if(props?.status?.hasOwnProperty('result')){
            toastNotify(props.status?.result?.status, props.status?.result?.message)
            // if(props.status?.result?.status === 'success'){
            //     history.replace('/dashboard/blogs/list')
            // }
        }
    }, [props.status])

    return (
        <React.Fragment>
            {loading ? <Loading />:
                <Form>
                    <div className={"w-3/5"}>
                        <Input name={"title"} label={"عنوان بلاگ"} placeholder={"عنوان..."} isRequired
                               meta={props.getFieldMeta('title')} defaultValue={props.values?.title}/>
                        <Input name={"slug"} label={"نامک بلاگ"} placeholder={"نامک..."} isRequired
                               meta={props.getFieldMeta('slug')} defaultValue={props.values?.slug}/>
                        <InputSelect name={'category'} label={'دسته بندی بلاگ'}
                                     placeholder={'دسته بندی بلاگ...'}
                                     handleSetValue={(values: any) => props.setFieldValue('category', values)}
                                     options={optionsCategories} isMultiple={true} error={props?.errors?.category}
                                     meta={props.getFieldMeta('category')}
                                     defaultValue={optionsCategories.filter((item, _) => props.values?.category?.includes(item?.value))}
                                     isRequired isClearable
                        />
                        <Input name={"summary"} as={'textarea'} label={"خلاصه متن برای بلاگ"} placeholder={"خلاصه متن برای بلاگ..."} isRequired
                               meta={props.getFieldMeta('summary')} defaultValue={props.values?.summary}/>
                        <MyCKEditor name={"content"} label={"متن برای بلاگ"} placeholder={"متن برای بلاگ..."} isRequired
                                    handleChangeValue={(value:string) => props.setFieldValue('content', value)}
                                    meta={props.getFieldMeta('content')} defaultValue={props.values?.content} />
                        <InputSelect name={'type'} label={'نوع فایل'}
                                     placeholder={'نوع فایل...'}
                                     handleSetValue={(values: any) => props.setFieldValue('type', values)}
                                     options={options} isMultiple={false} error={props?.errors?.type}
                                     meta={props.getFieldMeta('type')}
                                     defaultValue={options.find((item, _) => item.value === props.values?.type)}
                        />
                        <Input name={"file"} label={"فایل بلاگ"} placeholder={"فایل..."}
                               meta={props.getFieldMeta('file')} defaultValue={props.values?.file}/>
                        <InputFile name={"image"} accept={".jpg,.jpeg,.png"} label={"عکس"}
                                   meta={props.getFieldMeta('image')} isImg handleUploadFile={props.setFieldValue}
                                   defaultValue={props.values?.image} isRequired
                        />
                    </div>
                    <div className={"text-left"}>
                        <Button title={props.status?.formType === 'create' ? "ثبت بلاگ جدید" : "بروزرسانی بلاگ"} isLoading={props.isSubmitting}/>
                    </div>
                </Form>}
        </React.Fragment>
    )
}

export default InnerBlogForm